
import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentoTipo } from '../../../models/documento-tipo.model';
import { DocumentoTipoService } from '../../../services/documento-tipo.service';


@Component({
  selector: 'app-documento-tipo-edit',
  templateUrl: './documento-tipo-edit.component.html',
  styleUrls: ['./documento-tipo-edit.component.scss']
})
export class DocumentoTipoEditComponent 
  extends BaseFormComponent<DocumentoTipo>
  implements OnInit{

    actionLabel: string = 'Novo';

    constructor(
      private myService: DocumentoTipoService,
      public activatedRoute: ActivatedRoute,
      private navigation: NavigationService
    ) {
      super(activatedRoute);
    }

    ngOnInit(): void {
      this.loaded();
      this.initForm();
    }

    initForm() {
      this.form = new FormGroup({
        name: new FormControl('', [
          Validators.required,
          Validators.maxLength(255),
        ]),
      });
  
      if (this.entity) {
        this.actionLabel = 'Editar';
        this.form.patchValue(this.entity);
      }
    }

    voltar() {
      this.navigation.back(['pre-projeto/admin/documento-tipo']);
    }

    getDataCreate(): DocumentoTipo {
      let data: DocumentoTipo;
      data = Object.assign({}, data, this.form.value);
      return data;
    }
  
    salvar(): void {
      if (this.form.valid) {
        this.loading();
        if (this.entity?.id) {
          this.addSub(
            this.myService
              .update(this.getDataCreate(), this.entity?.id)
              .subscribe({
                next: (res: DocumentoTipo) => {
                  this.msgSuccess('Cadastro alterado com sucesso!');
                  this.loaded();
                },
                error: (error) => {
                  this.msgError(error?.error.message);
                  this.loaded();
                },
              })
          );
        } else {
          this.addSub(
            this.myService.create(this.getDataCreate()).subscribe({
              next: (res: DocumentoTipo) => {
                this.msgSuccess('Cadastro criado com sucesso!');
                this.navigation.replace([
                  'pre-projeto/admin/documento-tipo/',
                  res.id,
                ]);
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error.message);
                this.loaded();
              },
            })
          );
        }
      } else {
        this.markAsDirty();
      }
    }

    confirmExcluir() {
      this.alertConfirmation().subscribe((confirmed) => {
        if (confirmed) {
          this.excluir();
        }
      });
    }
  
    excluir(): void {
      this.loading();
      this.myService.delete(this.entity?.id).subscribe({
        next: (res) => {
          this.confirmation('Deletado com sucesso').subscribe(() => {
            this.navigation.replace(['pre-projeto/admin/documento-tipo']);
          });
        },
        error: (error) => {
          this.loaded();
          this.msgError(error?.error.message);
        },
      });
    }

}
